import { Box, Button, Container, Typography, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./MsWellDoneScreen.css";
import { useConfig } from "../../contexts/ConfigContext";

function MsWellDoneScreen() {
  const { config } = useConfig();
  return (
    <Grid className="ms-set-password-container ms-well-done-screen">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        <img src="/ciam/v1/static/images/ms/right-circle.svg" alt="right-circular-gradient" />
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box alignItems="center" textAlign="center">
            <CheckCircleIcon className="ms-success-icon" />
            <Typography
              variant="h5"
              fontWeight="600"
              gutterBottom
              className="ms-set-password-title"
              style={{ marginTop: "32px", marginBottom: "8px" }}
            >
              Well done!
            </Typography>
            <Typography variant="body1" gutterBottom className="ms-set-password-description">
              The Password has been updated and you can log in with your new password.
            </Typography>

            <form noValidate>
              <Button
                variant="contained"
                color="primary"
                className="ms-login-button"
                fullWidth
                sx={{ mt: 3 }}
                onClick={() => (window.location.href = config?.reportalLoginUrlMS1)}
              >
                Log In
              </Button>
            </form>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default MsWellDoneScreen;
